import { throttle } from 'throttle-debounce'

export default () => ({
    activeIndex: 0,
    stickyTopOffset: 0,
    progress: 0,

    init() {
        const boundCalculate = this.calculate.bind(this)

        this.calculate()
        window.addEventListener('resize', boundCalculate)
        window.addEventListener('scroll', boundCalculate)

        this.$watch('progress', (progress) => {
            const videos = this.$refs.videos.children
            const video = videos[this.activeIndex]?.querySelector('video')

            if (video && video.duration) {
                video.currentTime = progress * video.duration
            }
        })
    },

    calculateStickyOffset() {
        const offset =
            (this.$refs.videos.offsetHeight - window.innerHeight) / -2

        this.stickyTopOffset = offset
    },

    calculateActiveIndexAndProgress() {
        const windowHeight = window.innerHeight
        const children = this.$refs.track.children
        let activeIndex = 0
        let progress = 0

        for (let i = 0; i < children.length; i++) {
            const child = children[i]
            const { top, height } = child.getBoundingClientRect()
            const childProgress = Math.max(
                0,
                Math.min(1, (windowHeight - top) / (windowHeight + height))
            )

            if (childProgress) {
                activeIndex = i
                progress = childProgress
            }
        }

        this.activeIndex = activeIndex
        this.progress = progress
    },

    calculate: throttle(1000 / 60, function () {
        this.calculateStickyOffset()
        this.calculateActiveIndexAndProgress()
    }),

    goTo(index) {
        this.$refs.track.children[index]?.scrollIntoView({
            behavior: 'smooth',
        })
    },
})
